import React from 'react';
import AppRouter from "./AppRouter";

function App() {
    return (
        <div className="app-container">
            <AppRouter />
        </div>
    );
}

export default App;